import React from 'react';  
import './index.css';
import * as util from 'common/util'
 
class InfoDes extends React.Component{
  numParse(num) {
      if (num.toString().length >= 9) {
          return util.spliceNum((num / 100000000).toFixed(3).slice(0,-1),1)
      }else if (num.toString().length >= 5) {
          return util.spliceNum((num / 10000).toFixed(3).slice(0,-1),0)
      }else {
          return num
      }
  }

  render(){
    const {data} = this.props;
    let clicknum = data.get('click_record_num') || '0';
        clicknum = this.numParse(clicknum);
    let learnnum = data.get('learn_record_num') || '0';
        learnnum = this.numParse(learnnum)
    return (
      <div className="info-des">
        <div className="des-title">
          <span>{data.get('title')?data.get('title'):'暂无'}</span>
        </div>
        <div className="des-tip">
        {
          data.get('category')?
          data.get('category').map((item,index)=>{
            return ( 
                <span key={index}>{item.getIn(['affiliate','name'])}</span>
              )
          }):
          null
        }
        </div>
        <div className="des-bottom">
          <div className="des-name">
           <img src={require('./img/avatar.png')} alt="" />
           <span   className="text-over">{data.get('realname')?data.get('realname'):'暂无'}</span>
          </div>
          <div className="des-info">
            <div className="info-actions">
              <div className="info-icon">
                <img src={require('./img/icon_eye.png')} alt="" />
              </div>
              <span>{clicknum}次观看</span>
            </div>
            <div className="info-actions">
              <div className="info-icon">
                <img src={require('./img/icon_book.png')} alt=""/>
              </div>
              <span>{learnnum}人学习</span>
            </div>
          </div>
        </div>
      </div>
      )
  }

}

export default InfoDes;